import {Fragment, h} from "preact";
import SignAddress from '../SignAddress/SignAddress'
import AlertCollapse from '../../../_common/components/AlertCollapse/AlertCollapse'
import { useSelector } from 'react-redux'
import { t } from '../../../_i18n'
import {isSpanishUser} from "../../../_common/utils/getLang";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";
import {DateTime} from "luxon";
import UploadDocumentWeekly from "../UploadDocumentWeekly/UploadDocumentWeekly";
import {useParams} from "react-router";


export default function AlertAnnexed ({ className }) {
    const {screenStatus, static_documents, static_annex_8_9_document} = useSelector(state => ({
        screenStatus: state.fct.screenState,
        static_documents: state.fct.static_documents,
        static_annex_8_9_document: state.fct.static_annex_8_9_document
    }))
    const evaluation_file = screenStatus.screen_data?.final_evaluation_mad;
    const { id } = useParams()
    const screenState = screenStatus.screen;
    const shopId = useSelector(state => state.status.student_meta.shop_id);
    const STATE_3 = '4.3'
    const STATE_3_5 = '4.35'
    const STATE_4 = '4.4'
    const STATE_4_5 = '4.45'

    switch (screenState) {
        case STATE_3_5:
            return (
                <AlertBox type='shadow'>
                    <h2>{t('📝 Instrucciones especiales para el Anexo')}</h2>
                    <ul className="m-top m-x2-bottom m-l m-r">
                        <li className='m-top'>{t('Fecha de inicio:')} {DateTime.fromISO(screenStatus.screen_data.contract_details.start_date).toFormat('dd/MM/yyyy')}</li>
                        <li className='m-top'>{t('Fecha de fin:')} {DateTime.fromISO(screenStatus.screen_data.contract_details.final_date).toFormat('dd/MM/yyyy')}</li>
                        <li className='m-top'>{t('Cada 15 días tendrás que subir a MI CUENTA la ficha semanal')}
                            <a href={static_annex_8_9_document.annex_8.url} target="_blank"> {t('(Anexo 8)')} </a> ,
                            {t('escaneada en PDF y firmada por tu tutor/a de prácticas.')}
                        </li>
                        <li className='m-top'>
                            {t('Una vez te queden unos días para finalizar las prácticas, deberás presentar el informe final')}
                            <a href={static_annex_8_9_document.annex_9.url} target="_blank"> {t('(Anexo 9)')} </a> ,
                            {t('en MI CUENTA para que podamos validarlo.')}
                        </li>
                        <li className='m-top'>
                            {t('Cuando hayas finalizado las prácticas, deberás enviar por correo postal tanto los anexos 8 firmados por tu tutor/a como el informe final de prácticas (Anexo 9). Todos los documentos deben de ser con las firmas originales.')}
                        </li>
                    </ul>
                    <SignAddress className='m-top m-l m-r m-bottom'/>
                    <AlertBox type="dashed m-x2-top m-l m-r ">
                        <span>{t('¡Recuerda! Si el tutor/a dispone de firma digital válida, no será necesario que lo entregues por correo postal.')}</span>
                    </AlertBox>
                </AlertBox>
            )
        case STATE_4:
            return (
                <AlertCollapse
                    title={t('👋 Nos tienes que enviar por correo postal los ‘Anexos 7’ originales y el ‘Anexo 8’')}
                    className={className}>
                    <ol>
                        <li>
                            {t('Descárgate el ')} <a
                            href={static_documents.tutor.url} target="_blank">{t('‘Informe del tutor del centro de trabajo (Anexo 8)’')}</a> {t('e imprímelo.')}
                            {!isSpanishUser(shopId) &&
                                <AlertBox type={"dashed"}>
                                    {t('fct_international_help')}
                                    <a href={t('fct_anexo_8_tutor_help_document_link')}>{t('fct_anexo_8_tutor_international_help_document')}.</a>
                                </AlertBox>
                            }
                        </li>
                        <li>{t('Tenéis que rellenarlo y firmarlo, tú y tu tutor de prácticas.')}</li>
                        <li>{t('Una vez rellenado y firmado, envíalo, junto a los ‘Anexos 7’ originales a la siguiente dirección:')}</li>
                    </ol>
                    <SignAddress className='m-top'/>
                </AlertCollapse>
            )
        case STATE_4_5:
            return (
                <AlertCollapse title={t('👋 Nos tienes que enviar por correo postal los ‘Anexos 8’ originales y el ‘Anexo 9’')} className={className}>
                    <ol>
                        <li>
                            {t('Descárgate la ')} <a href={static_annex_8_9_document.annex_9.url} target="_blank">{t('‘plantilla de informe de valoración final (Anexo 9)’')}</a> {t('e imprímelo.')}
                        </li>
                        <li>{t('Tenéis que rellenarlo y firmarlo, tú y tu tutor de prácticas.')}</li>
                        <li>
                            {t('Una vez rellenado y firmado, envíalo, junto a los ')}
                            <a href={static_annex_8_9_document.annex_8.url} target="_blank">{t('‘Anexos 8’')}</a>
                            {t(' originales a la siguiente dirección:')}
                            <SignAddress className='m-top'/>
                        </li>
                        {(evaluation_file !== null && (!evaluation_file?.file_name|| evaluation_file.error_msg)) && <li>{t('Adjunta el documento cumplimentado y firmado.')}</li> }
                    </ol>
                    {(evaluation_file !== null && (!evaluation_file?.file_name || evaluation_file.error_msg)) && <UploadDocumentWeekly contractId={id} typeDocument='final_evaluation_mad' className='m-top-x2'/> }
                </AlertCollapse>
            )
        default:
            return (
                <AlertBox type='shadow'>
                    <h2>{t('📝 Instrucciones especiales para el Anexo')}</h2>
                    <ul>
                        <li className='m-top'>{t('Fecha de inicio:')} {DateTime.fromISO(screenStatus.screen_data.contract_details.start_date).toFormat('dd/MM/yyyy')}</li>
                        <li className='m-top'>{t('Fecha de fin:')} {DateTime.fromISO(screenStatus.screen_data.contract_details.final_date).toFormat('dd/MM/yyyy')}</li>
                        <li className='m-top'>{t('Cada 15 días tendrás que enviarnos la ‘Ficha semanal del alumno (Anexo 7)’ firmado por tu tutor, para hacer seguimiento.')}</li>
                        {screenState === STATE_3 &&
                            <li className='m-top'>{t('Cuando queden 10 días para finalizar tus prácticas, tendrás que enviarnos por correo postal el')}
                                <a href={static_documents.tutor.url} target="_blank">{t("‘Anexo 8 (Informe del tutor del centro de trabajo)’")}</a> {t('firmado por tu tutor.')}</li>}
                        {screenState === STATE_3 && !isSpanishUser(shopId) &&
                            <AlertBox type={"info"}>
                                {t('fct_international_help')}
                                <a href={t('fct_anexo_8_tutor_help_document_link')}>{t('fct_anexo_8_tutor_international_help_document')}.</a>
                            </AlertBox>
                        }
                    </ul>
                </AlertBox>
            )
    }

}
